import React from 'react'
import { find } from 'lodash/collection'
import PropTypes from 'prop-types'
import { StyledSelect } from './styles'

const SelectOneInput = ({ options, setSelected, selected, size }) => {
  const handleChange = (selectedOption) => {
    setSelected(selectedOption.value)
  }
  return (
    <StyledSelect
      classNamePrefix="rs"
      onChange={handleChange}
      options={options}
      size={size}
      isWhite
      isScroll={false}
      value={find(options, (option) => option.value === selected)}
    />
  )
}

export default SelectOneInput

SelectOneInput.defaultProps = {
  size: "100%",
  selected: null
}

SelectOneInput.propTypes = {
  selected: PropTypes.any,
  setSelected: PropTypes.func.isRequired,
  size: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.any, label: PropTypes.string })
  ).isRequired
}
